<template>
  <div>
    <general-information
      v-if="localItem.generalInformation"
      v-model="localItem.generalInformation"
      :readonly="readonly"
    />
    <filters
      :filters="localItem.filters"
      :readonly="readonly"
      @change-filters="changeFilters"
    />
    <recipients
      v-if="localItem.filters"
      :notificationId="notificationId"
      :filters="localItem.filters"
      :recipients-selected-before="recipients"
      :readonly="readonly"
      @change-selected-recipients="changeSelectedRecipients"
    />
  </div>
</template>

<script>
export default {
  name: 'NotificationBuild',

  components: {
    GeneralInformation: () =>
      import('@/modules/notifications/components/GeneralInformation.vue'),
    Filters: () => import('@/modules/notifications/components/Filters.vue'),
    Recipients: () =>
      import('@/modules/notifications/components/Recipients.vue')
  },

  model: {
    prop: 'itemOutside',
    event: 'input'
  },

  props: {
    itemOutside: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localItem: null,
    recipients: null,
    notificationId: null
  }),

  watch: {
    localItem: {
      deep: true,
      handler: 'updateItemOutside'
    }
  },

  created() {
    this.localItem = Object.assign({}, this.itemOutside);
    this.recipients = this.localItem.recipients;
    if(this.localItem.id){
      this.notificationId = this.localItem.id;
    }
  },

  methods: {
    updateItemOutside() {
      this.$emit('input', this.localItem);
    },

    checkGeneralInformation(trueORfalse){
      this.valid = trueORfalse;
    },

    changeFilters(filters) {
      this.localItem.filters = filters;
      this.localItem.recipients = null;
      this.recipients = null;
    },

    changeSelectedRecipients(users) {
      this.localItem.recipients = [];
      users.forEach(user => {
        this.localItem.recipients.push(user.id);
      });
    }
  }
};
</script>
